





























import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class CalendarButton extends Vue {
    @Prop() private userConfigColor! : string;

    onClickInsertObjectButton(object: string){
        this.$emit("onClickInsertObjectButton", object);
    }
}
